import { Hero02livetv } from './Images.js';
import LiveTVCarousel from './LiveTVCarousel';
import HeroImage from './components/HeroImage';
import './css/App.css';

import { useDocumentTitle } from "./hooks/useDocumentTitle";
import { useMediaQuery } from 'react-responsive';

function LiveTV() {

  useDocumentTitle("Live TV")
  const isMobile = useMediaQuery({ query: `(max-width: 960px)` });

  return (
      <div className="sectionbody">
        <div className={isMobile ? "hero-image-area-mobile" : "hero-image-area"}>
          <HeroImage src={Hero02livetv} alt="Kate the Chemist on Live TV" />
        </div>

        <div className={isMobile ? "intro-paragraph-area-mobile" : "intro-paragraph-area"}>
        <h1>Live TV!</h1>
        <h2><em>Featured on The Today Show, The Kelly Clarkson Show, The Late Show with Stephen Colbert and more!</em></h2>
          
          <p>Dr. Kate Biberdorf is a chemist, science entertainer, and professor at Notre Dame. Through her theatrical and hands-on approach to teaching, Dr. Biberdorf is breaking down the image of the stereotypical scientist, while reaching students who might otherwise be intimidated by science. As the first Professor for the Public Understanding of Science at Notre Dame, Dr. Biberdorf uses fire and explosions to highlight and amplify the groundbreaking science happening on campus.</p>
        </div>

        <div className="blue-bg-area">
            <LiveTVCarousel />
        </div>

      </div>


  );
}

export default LiveTV;
